import type { SubscriptionPlanTier } from '../types';

/**
 * Centralized subscription plan tier mapping utilities.
 * The only real mapping needed: DB uses 'professional', frontend uses 'pro'.
 * All other tiers pass through as-is, so new plans work automatically.
 */

export function mapDbTierToFrontend(dbTier: string): SubscriptionPlanTier {
  if (dbTier === 'professional') return 'pro';
  return dbTier as SubscriptionPlanTier;
}

export function mapFrontendTierToDb(frontendTier: SubscriptionPlanTier): string {
  if (frontendTier === 'pro') return 'professional';
  return frontendTier;
}

/**
 * Plan hierarchy for feature gating.
 * Unknown/new plans default to enterprise-level (3) so they get full access.
 */
export function getPlanLevel(tier: string): number {
  const levels: Record<string, number> = {
    basic: 1,
    pro: 2,
    professional: 2,
    enterprise: 3,
    tester: 3,
  };
  return levels[tier] ?? 3;
}
